import { socket } from '../core/socket.js';
import { state } from '../core/state.js';
import { t } from '../core/i18n.js';
import { escapeHtml } from '../utils/formatters.js';
import { chaosNotify, popToast } from '../utils/alerts.js';
import { naviguer } from './navigation.js';
import { toggleSettings } from './modals.js';
import { nomAfficheDe } from './messages.js';
import { majBoutonCreerSalon } from './channels.js';

const utilisateurs  = state.utilisateurs;
const notifications = state.notifications;

function _bannerUrl(id) {
    if (!id || id === 'none' || id === '1' || String(id) === 'undefined') return null;
    return id.startsWith('/uploads/') ? id : `/img/banners/${id}`;
}

export function _renderBanniere(el, banniereId, couleur) {
    el.querySelectorAll('.banner-video').forEach(v => { try { v.pause(); } catch(_) {} v.remove(); });
    const url = _bannerUrl(banniereId);
    if (!url) { el.style.background = couleur || '#58a6ff'; return; }
    if (/\.(mp4|webm)$/i.test(url)) {
        el.style.background = 'none';
        el.style.position = 'relative';
        el.style.overflow = 'hidden';
        const vid = document.createElement('video');
        vid.className = 'banner-video';
        vid.src = url; vid.autoplay = true; vid.muted = true; vid.loop = true; vid.playsInline = true;
        el.appendChild(vid);
    } else {
        el.style.background = `url('${url}') center/cover no-repeat`;
    }
}

// ==========================================================================
//   BULLES MP — création / suppression
// ==========================================================================

export function gererBulleMP(pseudo, couleur) {
    const container = document.getElementById('active-conversations');
    if (!container || !pseudo) return;

    let pseudoFinal = "";
    if (typeof pseudo === 'string') {
        pseudoFinal = pseudo;
    } else if (pseudo && typeof pseudo === 'object') {
        pseudoFinal = pseudo.pseudo || pseudo.auteur || JSON.stringify(pseudo);
    }

    if (pseudoFinal.includes('"')) {
        try {
            const obj = JSON.parse(pseudoFinal);
            pseudoFinal = obj.pseudo || obj.auteur || pseudoFinal;
        } catch(e) {
            pseudoFinal = pseudoFinal.replace(/["{}]/g, '').split(',')[0].split(':')[1] || pseudoFinal;
        }
    }
    pseudoFinal = pseudoFinal.trim();

    // Pas de bulle pour ses propres messages
    if (pseudoFinal === state.monPseudo) return;

    let bulle = document.querySelector(`.active-contact-bubble[data-pseudo="${pseudoFinal}"]`);

    if (!bulle && !couleur) return;

    if (!bulle && couleur) {
        bulle = document.createElement('div');
        bulle.className = 'active-contact-bubble sphere-icon';
        bulle.dataset.pseudo = pseudoFinal;
        bulle.style.cursor = "pointer";

        const userData = state.utilisateurs?.[pseudoFinal];
        const avatarUrl = userData?.avatar_url && userData.avatar_url !== 'none' && userData.avatar_url !== 'undefined'
            ? userData.avatar_url : null;
        const couleurFinale = couleur || userData?.couleur || '#58a6ff';

        if (avatarUrl) {
            const img = document.createElement('img');
            img.src = avatarUrl;
            img.alt = '';
            bulle.appendChild(img);
        } else {
            bulle.style.setProperty('--bubble-color', couleurFinale);
            const initSpan = document.createElement('span');
            initSpan.className = 'bubble-initial';
            initSpan.textContent = pseudoFinal.charAt(0).toUpperCase();
            bulle.appendChild(initSpan);
        }

        bulle.title = t('chat.mp_bubble_title', {pseudo: pseudoFinal});
        bulle.onclick = () => { naviguer('mp', { pseudo: pseudoFinal }); };
        bulle.draggable = true;

        bulle.ondragstart = (e) => {
            e.dataTransfer.setData("text/plain", pseudoFinal);
            const vortex = document.getElementById('vortex-container');
            if (vortex) { vortex.style.display = 'flex'; setTimeout(() => vortex.classList.add('active'), 10); }
        };
        bulle.ondragend = () => {
            const vortex = document.getElementById('vortex-container');
            if (vortex) { vortex.classList.remove('active'); setTimeout(() => vortex.style.display = 'none', 500); }
        };

        const closeBtn = document.createElement('span');
        closeBtn.className = 'close-bubble';
        closeBtn.innerHTML = '×';
        closeBtn.onclick = (e) => {
            e.stopPropagation();
            bulle.remove();
            socket.emit('marquer-lu', { expediteur: pseudoFinal, destinataire: state.monPseudo });
            if (container.querySelectorAll('.active-contact-bubble').length === 0) {
                const s = document.getElementById('sep-mp');
                if (s) s.style.display = 'none';
            }
        };
        bulle.appendChild(closeBtn);

        container.appendChild(bulle);
        const sep = document.getElementById('sep-mp');
        if (sep) sep.style.display = 'block';
    }

    // Si la bulle a encore son initiale, tenter de la remplacer par l'avatar maintenant
    const initExistante = bulle.querySelector('.bubble-initial');
    if (initExistante) {
        const ud = state.utilisateurs?.[pseudoFinal];
        const av = ud?.avatar_url && ud.avatar_url !== 'none' && ud.avatar_url !== 'undefined' ? ud.avatar_url : null;
        if (av && !bulle.querySelector('img')) {
            const img = document.createElement('img');
            img.src = av;
            img.alt = '';
            bulle.insertBefore(img, initExistante);
            initExistante.remove();
        }
    }

    const nbNotifs = notifications[pseudoFinal] || 0;
    let badge = bulle.querySelector('.bubble-notif-badge');
    if (nbNotifs > 0) {
        if (!badge) {
            badge = document.createElement('span');
            badge.className = 'bubble-notif-badge';
            bulle.appendChild(badge);
        }
        badge.innerText = nbNotifs;
    } else if (badge) {
        badge.remove();
    }
}

export function supprimerBulleSiLue(pseudo) {
    const data = notifications[pseudo];
    const nbNotifs = (data && typeof data === 'object') ? data.count : (data || 0);
    if (nbNotifs === 0) {
        const bulle = document.querySelector(`.active-contact-bubble[data-pseudo="${pseudo}"]`);
        if (bulle) {
            bulle.remove();
            const container = document.getElementById('active-conversations');
            if (container && container.querySelectorAll('.active-contact-bubble').length === 0) {
                const sep = document.getElementById('sep-mp');
                if (sep) sep.style.display = 'none';
            }
        }
    }
}

// ==========================================================================
//   SOCIAL — RECHERCHE D'AGENT
// ==========================================================================

export function validerRechercheAgent() {
    const inputEl = document.getElementById('input-recherche-pseudo');
    const pseudo = inputEl.value.trim();
    if (pseudo && pseudo !== state.monPseudo) {
        socket.emit('envoyer-demande-ami', pseudo);
        window.fermerModaleRecherche();
        inputEl.value = "";
    } else {
        popToast(t('validate.pseudo_invalid'), 'error');
    }
}

document.getElementById('input-recherche-pseudo').addEventListener('keypress', (e) => {
    if (e.key === 'Enter') validerRechercheAgent();
});

// ==========================================================================
//   SOCIAL — DEMANDES D'AMIS
// ==========================================================================

socket.on('voici-les-demandes-en-attente', (demandes) => {
    const badge = document.getElementById('request-count-badge');
    const container = document.getElementById('container-demandes-attente');
    if (!container) return;

    if (demandes.length > 0) {
        badge.innerText = demandes.length;
        badge.style.display = 'flex';
        document.getElementById('inbox-trigger').style.color = "#58a6ff";
    } else {
        badge.style.display = 'none';
        document.getElementById('inbox-trigger').style.color = "#8b949e";
    }

    container.innerHTML = '';

    if (demandes.length === 0) {
        container.innerHTML = `<p class="empty-msg">${t('social.no_requests')}</p>`;
    } else {
        const titre = document.createElement('h3');
        titre.className = 'social-subtitle-inbox';
        titre.innerText = t('social.requests_title');
        container.appendChild(titre);

        demandes.forEach(demande => {
            const estEntrante = demande.receveur_pseudo === state.monPseudo;
            const pseudoAffiche = estEntrante ? demande.demandeur_pseudo : demande.receveur_pseudo;
            const couleurAffiche = estEntrante ? demande.couleur_demandeur : demande.couleur_receveur;

            const div = document.createElement('div');
            div.className = 'demande-item';

            let actionsHtml = '';
            if (estEntrante) {
                actionsHtml = `
                    <button class="btn-action accept" data-action="accepte" title="${t('social.btn_accept')}">
                        <svg viewBox="0 0 24 24" fill="none" stroke="#23a559" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                    </button>
                    <button class="btn-action refuse" data-action="refuse" title="${t('social.btn_decline')}">
                        <svg viewBox="0 0 24 24" fill="none" stroke="#f23f43" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>
                `;
            } else {
                actionsHtml = `
                    <button class="btn-action refuse" data-action="annuler" title="${t('social.btn_cancel_request')}">
                        <svg viewBox="0 0 24 24" fill="none" stroke="#f23f43" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>
                `;
            }

            const urlAvatarReq = estEntrante ? demande.avatar_demandeur : demande.avatar_receveur;
            let avatarReqStyle = `background-color: ${couleurAffiche || '#58a6ff'};`;
            let avatarReqTexte = pseudoAffiche.charAt(0).toUpperCase();
            if (urlAvatarReq && urlAvatarReq !== 'none' && String(urlAvatarReq) !== 'undefined') {
                avatarReqStyle = `background: url('${urlAvatarReq}') center/cover no-repeat; border: 2px solid ${couleurAffiche || '#58a6ff'}; color: transparent;`;
                avatarReqTexte = "";
            }

            div.innerHTML = `
            <div class="ami-info">
                <span class="ami-avatar" style="${avatarReqStyle}">${avatarReqTexte}</span>
                <span class="ami-pseudo">
                    ${pseudoAffiche}
                    <span style="font-size: 0.7em; opacity: 0.7;">${estEntrante ? t('social.request_received') : t('social.request_sent')}</span>
                </span>
            </div>
            <div class="ami-actions">${actionsHtml}</div>
            `;
            div.querySelectorAll('[data-action]').forEach(btn => {
                btn.addEventListener('click', () => {
                    const action = btn.dataset.action;
                    if (action === 'accepte' || action === 'refuse') repondreAmi(pseudoAffiche, action);
                    else if (action === 'annuler') annulerDemande(pseudoAffiche);
                });
            });
            container.appendChild(div);
        });
    }
});

export function repondreAmi(expediteur, action) {
    socket.emit('repondre-demande-ami', { expediteur, action });
}

export function annulerDemande(pseudo) {
    socket.emit('annuler-demande-ami', pseudo);
}

socket.on('succes-social', (data) => {
    const msg = (data && data.key) ? t(data.key, data.params || {}) : String(data);
    chaosNotify(msg, t('alert.social_update_title'), "alert");
});

socket.on('demande-ami-mise-a-jour', () => {
    socket.emit('demander-liste-amis');
});

// ==========================================================================
//   SOCIAL — LISTE D'AMIS
// ==========================================================================

// 1. Déclare la variable de stockage tout en haut de ton fichier social.js (si ce n'est pas déjà fait)
export let listeAmisData = [];

// 2. Ton écouteur socket qui stocke et passe la main à la fonction UI
socket.on('voici-tes-amis', (amis) => {
    listeAmisData = amis || [];
    window.mesAmisActuels = amis.map(a => a.ami_pseudo);
    rafraichirListeAmisUI();
});

// 3. Ta fonction d'affichage isolée, basée à 100% sur ton code d'origine
export function rafraichirListeAmisUI() {
    const container = document.getElementById('liste-amis-social');
    if (!container) return;
    container.innerHTML = '';

    const formaterStatut = (s) => {
        const map = {
            'enligne':   'status.label.online',
            'absent':    'status.label.away',
            'occupe':    'status.label.busy',
            'invisible': 'status.label.invisible',
        };
        if (!s || s === 'horsligne' || s === 'inconnu') return t('status.label.offline');
        return map[s] ? t(map[s]) : s.charAt(0).toUpperCase() + s.slice(1);
    };

    if (listeAmisData.length === 0) {
        container.innerHTML = `<p style="color: #8b949e; font-style: italic;">${t('social.empty')}</p>`;
        return;
    }

    listeAmisData.forEach(ami => {
        const urlAvatar = ami.avatar_url || (state.utilisateurs[ami.ami_pseudo] ? state.utilisateurs[ami.ami_pseudo].avatar_url : null);
        let avatarStyle = `background-color: ${ami.couleur_preferee || '#58a6ff'};`;
        let avatarTexte = ami.ami_pseudo.charAt(0).toUpperCase();
        
        if (urlAvatar && urlAvatar !== 'none' && String(urlAvatar) !== 'undefined') {
            avatarStyle = `background: url('${urlAvatar}') center/cover no-repeat; border: 2px solid ${ami.couleur_preferee || '#58a6ff'}; color: transparent;`;
            avatarTexte = "";
        }

        const div = document.createElement('div');
        div.className = 'ami-card-row';

        const svgMsg = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>`;
        const svgDots = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="1"/><circle cx="12" cy="5" r="1"/><circle cx="12" cy="19" r="1"/></svg>`;

        const statutTempsReel = utilisateurs[ami.ami_pseudo]?.statut || null;
        const enLigneTempsReel = !!utilisateurs[ami.ami_pseudo]?.enLigne;
        const statutAffiche = enLigneTempsReel ? (statutTempsReel || ami.ami_statut_presence) : 'horsligne';

        div.innerHTML = `
            <div class="ami-left-side" onclick="naviguer('mp', { pseudo: '${ami.ami_pseudo}' })">
                <span class="ami-avatar" style="${avatarStyle}">${avatarTexte}</span>
                <div class="ami-name-group">
                    <span class="ami-pseudo-text">${ami.ami_pseudo}</span>
                    <span class="ami-status-sub">${formaterStatut(statutAffiche)}</span>
                </div>
            </div>
            <div class="ami-actions-side">
                <div class="action-circle" onclick="naviguer('mp', { pseudo: '${ami.ami_pseudo}' })" title="Message">${svgMsg}</div>
                <div class="action-circle more-trigger" onclick="ouvrirMenuAmi(event, '${ami.ami_pseudo}')">${svgDots}</div>
            </div>
        `;
        container.appendChild(div);
    });
}

// ==========================================================================
//   PROFIL ÉTENDU — modale ami
// ==========================================================================

export function ouvrirMenuAmi(event, pseudo) {
    if (event) event.stopPropagation();

    const infosAuteur = utilisateurs[pseudo] || {};
    const couleur = infosAuteur.couleur || '#58a6ff';
    const urlAvatar = infosAuteur.avatar_url;
    const banniereId = infosAuteur.banniere_id;
    const statutActuel = infosAuteur.statut || 'horsligne';
    const dicoCouleurs = { 'enligne': '#3fb950', 'occupe': '#f85149', 'absent': '#d29922', 'invisible': '#8b949e', 'horsligne': '#8b949e' };

    document.getElementById('ext-profile-pseudo').innerText = pseudo;
    document.getElementById('ext-profile-bio').innerText = t('profile.loading');
    document.getElementById('ext-no-activity-text').innerText = t('profile.no_activity', {pseudo});

    const statusDot = document.getElementById('ext-profile-status-dot');
    if (statusDot) statusDot.style.backgroundColor = dicoCouleurs[statutActuel] || '#8b949e';

    const banner = document.getElementById('ext-profile-banner');
    _renderBanniere(banner, banniereId, couleur);

    const avatar = document.getElementById('ext-profile-avatar');
    if (urlAvatar && urlAvatar !== 'none' && String(urlAvatar) !== 'undefined') {
        avatar.style.background = `url('${urlAvatar}') center/cover no-repeat`;
        avatar.innerHTML = '';
    } else {
        avatar.style.background = '#0d1117';
        avatar.style.color = couleur;
        avatar.innerHTML = pseudo.charAt(0).toUpperCase();
    }

    document.getElementById('ext-profile-btn-msg').onclick = () => {
        document.getElementById('modal-extended-profile').style.display = 'none';
        naviguer('mp', { pseudo });
    };

    const _estMoi2 = (pseudo === state.monPseudo);
    const _estAmi = !_estMoi2 && !!(window.mesAmisActuels?.includes(pseudo));
    const btnAdd  = document.getElementById('ext-profile-btn-add');
    const btnMenu = document.getElementById('ext-profile-btn-menu');
    const btnRemove = document.getElementById('ext-btn-remove');
    const btnSep  = document.getElementById('ext-dropdown-sep');

    // Bouton "ajouter" : visible seulement si pas soi-même et pas déjà ami
    btnAdd.style.display = (!_estMoi2 && !_estAmi) ? '' : 'none';
    btnAdd.disabled = false;
    btnAdd.innerHTML = '<i class="fas fa-user-plus"></i>';
    btnAdd.onclick = () => {
        socket.emit('envoyer-demande-ami', pseudo);
        popToast(t('toast.friend_request', { pseudo }));
        btnAdd.disabled = true;
        btnAdd.innerHTML = '<i class="fas fa-clock"></i>';
        btnAdd.title = 'Demande envoyée';
    };

    // Bouton 3-points + "Retirer l'ami" : visibles seulement hors propre profil
    btnMenu.style.display = _estMoi2 ? 'none' : 'inline-flex';
    btnRemove.style.display = _estAmi ? '' : 'none';
    if (btnSep) btnSep.style.display = _estAmi ? '' : 'none';

    document.getElementById('ext-btn-invite').onclick = (e) => {
        e.stopPropagation();
        const subMenu = document.getElementById('sphere-invite-submenu');
        subMenu.innerHTML = `<div class="dropdown-header">${t('sphere.invite_where')}</div>`;

        if (!window.mesSpheresActuelles || window.mesSpheresActuelles.length === 0) {
            subMenu.innerHTML += `<div class="menu-item" style="opacity:0.5;">${t('sphere.no_sphere_available')}</div>`;
        } else {
            window.mesSpheresActuelles.forEach(sphere => {
                const item = document.createElement('div');
                item.className = 'menu-item';
                item.innerText = `🌀 ${sphere.nom}`;
                item.onclick = () => {
                    socket.emit('generer-et-envoyer-invitation-mp', { sphereId: sphere.id, cible: pseudo });
                    popToast(t('toast.sphere_invite', {sphere: sphere.nom, pseudo}));
                    document.getElementById('modal-extended-profile').style.display = 'none';
                    document.getElementById('ext-profile-dropdown').style.display = 'none';
                    subMenu.style.display = 'none';
                };
                subMenu.appendChild(item);
            });
        }

        const rectBtn = document.getElementById('ext-btn-invite').getBoundingClientRect();
        subMenu.style.left = `${rectBtn.left - 205}px`;
        subMenu.style.top = `${rectBtn.top}px`;
        subMenu.style.zIndex = '5005';
        subMenu.style.display = 'block';
    };

    document.getElementById('ext-btn-remove').onclick = () => {
        document.getElementById('modal-extended-profile').style.display = 'none';
        document.getElementById('ext-profile-dropdown').style.display = 'none';
        window.agentContextuelActuel = pseudo;
        actionAgent('retirer');
    };

    const _estMoi = (pseudo === state.monPseudo);
    ['amis', 'spheres'].forEach(tab => {
        const tb = document.getElementById('ext-tab-' + tab);
        if (tb) { tb.hidden = _estMoi; tb.textContent = tb.dataset.base; }
        const pn = document.getElementById('ext-panel-' + tab);
        if (pn) pn.innerHTML = '';
    });
    switchExtTab('activite');

    window._extProfilePseudo = pseudo;
    document.getElementById('modal-extended-profile').style.display = 'flex';
    _majActiviteSpotify(pseudo);
    socket.emit('get-user-profile', pseudo);
}

export function switchExtTab(tab) {
    ['activite', 'amis', 'spheres'].forEach(name => {
        const tb = document.getElementById('ext-tab-' + name);
        const pn = document.getElementById('ext-panel-' + name);
        if (tb) tb.classList.toggle('actif', name === tab);
        if (pn) pn.style.display = (name === tab) ? 'flex' : 'none';
    });
}

function _remplirCommuns(data) {
    if (!data || data.pseudo === state.monPseudo) return;
    const amis = Array.isArray(data.amisCommuns) ? data.amisCommuns : [];
    const spheres = Array.isArray(data.spheresCommunes) ? data.spheresCommunes : [];

    const tA = document.getElementById('ext-tab-amis');
    const tS = document.getElementById('ext-tab-spheres');
    if (tA) { tA.hidden = false; tA.textContent = tA.dataset.base + (amis.length ? ` (${amis.length})` : ''); }
    if (tS) { tS.hidden = false; tS.textContent = tS.dataset.base + (spheres.length ? ` (${spheres.length})` : ''); }

    const _av = (el, url, fallbackColor, lettre) => {
        if (url && url !== 'none' && String(url) !== 'undefined') {
            el.style.backgroundImage = `url('${url}')`;
        } else {
            el.style.background = fallbackColor;
            el.textContent = (lettre || '?').charAt(0).toUpperCase();
        }
    };

    const pA = document.getElementById('ext-panel-amis');
    if (pA) {
        pA.innerHTML = '';
        if (!amis.length) {
            pA.innerHTML = '<div class="ext-common-empty">Aucun ami en commun.</div>';
        } else amis.forEach(a => {
            const row = document.createElement('div');
            row.className = 'ext-common-row';
            const av = document.createElement('div');
            av.className = 'ext-common-av';
            _av(av, a.avatar_url, a.couleur_preferee || '#58a6ff', a.nom_affiche || a.pseudo);
            const nom = document.createElement('span');
            nom.className = 'ext-common-nom';
            nom.style.color = a.couleur_preferee || '#f0f6fc';
            nom.textContent = a.nom_affiche || a.pseudo;
            row.appendChild(av); row.appendChild(nom);
            row.onclick = () => ouvrirMenuAmi(null, a.pseudo);
            pA.appendChild(row);
        });
    }

    const pS = document.getElementById('ext-panel-spheres');
    if (pS) {
        pS.innerHTML = '';
        if (!spheres.length) {
            pS.innerHTML = '<div class="ext-common-empty">Aucune sphère en commun.</div>';
        } else spheres.forEach(s => {
            const row = document.createElement('div');
            row.className = 'ext-common-row';
            const av = document.createElement('div');
            av.className = 'ext-common-av';
            _av(av, s.icone_url, '#3a3d44', s.nom);
            const nom = document.createElement('span');
            nom.className = 'ext-common-nom';
            nom.textContent = s.nom;
            row.appendChild(av); row.appendChild(nom);
            row.onclick = () => {
                document.getElementById('modal-extended-profile').style.display = 'none';
                naviguer('sphere', { id: s.id, nom: s.nom });
            };
            pS.appendChild(row);
        });
    }
}

export function toggleExtMenu() {
    const menu = document.getElementById('ext-profile-dropdown');
    menu.style.display = menu.style.display === 'none' ? 'block' : 'none';
}

// ==========================================================================
//   PROFIL — socket user-profile-data
// ==========================================================================

socket.on('user-profile-data', (data) => {
    if (data && data.pseudo) {
        utilisateurs[data.pseudo] = Object.assign(utilisateurs[data.pseudo] || {}, {
            banniere_id: data.banniere_id || null,
            avatar_url: data.avatar_url || null,
            couleur: data.couleur_preferee || (utilisateurs[data.pseudo] && utilisateurs[data.pseudo].couleur) || '#58a6ff',
            bio: data.bio || null,
        });
    }

    const popover = document.getElementById('profile-popover');

    if (popover.style.display === 'block') {
        document.getElementById('pop-bio').textContent = data.bio || "Pas encore de bio...";

        const banner = document.getElementById('pop-banner');
        _renderBanniere(banner, data.banniere_id, data.couleur_preferee);
        banner.style.height = "80px";
        banner.style.borderRadius = "8px 8px 0 0";

        const popAv = document.getElementById('pop-avatar');
        popAv.style.all = "unset";
        popAv.style.display = "flex";
        popAv.style.alignItems = "center";
        popAv.style.justifyContent = "center";
        popAv.style.width = "64px";
        popAv.style.height = "64px";
        popAv.style.borderRadius = "50%";
        popAv.style.border = `4px solid #0d1117`;
        popAv.style.boxShadow = `0 0 10px ${data.couleur_preferee || '#58a6ff'}40`;
        popAv.style.position = "relative";
        popAv.style.marginTop = "-32px";
        popAv.style.marginLeft = "15px";
        popAv.style.zIndex = "2";

        if (data.avatar_url) {
            popAv.textContent = "";
            popAv.style.backgroundImage = `url('${data.avatar_url}')`;
            popAv.style.backgroundSize = "cover";
            popAv.style.backgroundPosition = "center";
            popAv.style.backgroundColor = "transparent";
        } else {
            popAv.textContent = data.pseudo.charAt(0).toUpperCase();
            popAv.style.backgroundImage = "none";
            popAv.style.backgroundColor = "#161b22";
            popAv.style.color = "white";
            popAv.style.fontSize = "1.5rem";
            popAv.style.fontWeight = "bold";
        }

        const popUsername = document.getElementById('pop-username');
        popUsername.style.marginLeft = "15px";
        popUsername.style.marginTop = "5px";
        popUsername.onclick = () => {
            document.getElementById('profile-popover').style.display = 'none';
            ouvrirMenuAmi(null, data.pseudo);
        };

        const popRole = document.getElementById('pop-role');
        if (popRole) {
            const roleLabels = { admin: '⚔️ Admin Global', modo: '🛡️ Modérateur Global' };
            const label = roleLabels[data.role_global];
            popRole.textContent = label || '';
            popRole.style.display = label ? 'block' : 'none';
        }

        const popBio = document.getElementById('pop-bio');
        popBio.style.marginLeft = "15px";
        popBio.style.marginTop = "5px";
        popBio.style.paddingBottom = "8px";

        window._popSpotifyPseudo = data.pseudo;
        _majPopoverSpotify(data.pseudo);
    }

    if (data.pseudo === state.monPseudo) {
        const couleurSelf = data.couleur_preferee || '#58a6ff';
        const selfAvatar = document.getElementById('self-avatar');
        const initAvatar = document.getElementById('self-avatar-initiale');

        if (selfAvatar) {
            if (data.avatar_url) {
                selfAvatar.style.backgroundImage = `url('${data.avatar_url}')`;
                selfAvatar.style.backgroundSize = 'cover';
                selfAvatar.style.backgroundPosition = 'center';
                selfAvatar.style.backgroundColor = 'transparent';
                if (initAvatar) initAvatar.style.display = 'none';
            } else {
                selfAvatar.style.backgroundImage = 'none';
                selfAvatar.style.backgroundColor = couleurSelf;
                if (initAvatar) {
                    initAvatar.style.display = 'block';
                    initAvatar.textContent = data.pseudo.charAt(0).toUpperCase();
                }
            }
        }

        const inputColor = document.getElementById('edit-color');
        const inputBio = document.getElementById('edit-bio');
        if (inputColor && data.couleur_preferee) {
            let cleanColor = data.couleur_preferee.substring(0, 7);
            if (!cleanColor.startsWith('#')) cleanColor = '#' + cleanColor;
            inputColor.value = cleanColor;
            const sw = document.getElementById('swatch-pseudo');
            if (sw) sw.style.background = cleanColor;
        }
        if (inputBio) inputBio.value = data.bio || '';

        // Sync avatar preview dans le dropdown
        const pdAvatar = document.getElementById('pd-avatar-preview');
        if (pdAvatar) {
            if (data.avatar_url) {
                pdAvatar.style.backgroundImage = `url('${data.avatar_url}')`;
                pdAvatar.style.backgroundColor = 'transparent';
                pdAvatar.textContent = '';
            } else {
                pdAvatar.style.backgroundImage = 'none';
                pdAvatar.style.backgroundColor = data.couleur_preferee || '#161b22';
                pdAvatar.textContent = (window.monPseudo || '?').charAt(0).toUpperCase();
            }
        }
        const inputBanner = document.getElementById('edit-banner');
        if (inputBanner && data.banniere_id) {
            if (data.banniere_id.startsWith('/uploads/')) {
                let opt = inputBanner.querySelector('option[data-custom="1"]');
                if (!opt) { opt = document.createElement('option'); opt.dataset.custom = '1'; inputBanner.appendChild(opt); }
                opt.value = data.banniere_id;
            }
            inputBanner.value = data.banniere_id;
        }

        // Mise à jour immédiate des pseudos dans les messages déjà affichés
        document.querySelectorAll(`.message-author[data-pseudo="${CSS.escape(data.pseudo)}"]`).forEach(el => {
            el.style.color = couleurSelf;
        });

        // Mise à jour du nom + avatar dans la barre des agents
        const liMoi = document.querySelector('.agent-item-moi');
        if (liMoi) {
            const agentName = liMoi.querySelector('.agent-name');
            if (agentName) agentName.style.color = couleurSelf;
            const agentAvatar = liMoi.querySelector('.agent-mini-avatar');
            if (agentAvatar) {
                agentAvatar.style.borderColor = couleurSelf;
                if (!agentAvatar.style.backgroundImage?.includes('url')) agentAvatar.style.color = couleurSelf;
            }
        }

        state.maCouleur = couleurSelf;
        window.maCouleur = couleurSelf;
    }

    const extModal = document.getElementById('modal-extended-profile');
    if (extModal && extModal.style.display === 'flex') {
        const pseudoModale = document.getElementById('ext-profile-pseudo').innerText;
        if (data.pseudo === pseudoModale) {
            document.getElementById('ext-profile-bio').textContent = data.bio || "Cet agent n'a pas encore rédigé ses archives.";
            const extRole = document.getElementById('ext-profile-role');
            if (extRole) {
                const roleLabels = { admin: '⚔️ Admin Global', modo: '🛡️ Modérateur Global' };
                const label = roleLabels[data.role_global];
                extRole.textContent = label || '';
                extRole.style.display = label ? 'block' : 'none';
            }
            _remplirCommuns(data);

            // Mise à jour des boutons add/remove selon le statut d'amitié réel
            if (typeof data.estAmi === 'boolean') {
                const btnAdd2    = document.getElementById('ext-profile-btn-add');
                const btnRemove2 = document.getElementById('ext-btn-remove');
                const btnSep2    = document.getElementById('ext-dropdown-sep');
                btnAdd2.style.display    = data.estAmi ? 'none' : 'inline-flex';
                btnRemove2.style.display = data.estAmi ? '' : 'none';
                if (btnSep2) btnSep2.style.display = data.estAmi ? '' : 'none';
            }
        }
    }

    if (data.pseudo === state.monPseudo) majParamsProfileCard(data);
});

// ==========================================================================
//   SIDEBAR — liste-agents
// ==========================================================================

socket.on('liste-agents', (agents, meta) => {
    const type = (meta && meta.type) || 'amis';

    if (agents && typeof agents === 'object') {
        for (const p in agents) utilisateurs[p] = agents[p];

        // Mise à jour différée des bulles MP créées avant que l'avatar soit connu
        for (const p in agents) {
            const bulle = document.querySelector(`.active-contact-bubble[data-pseudo="${p}"]`);
            if (!bulle) continue;
            const ag = agents[p];
            const avatarUrl = ag.avatar_url && ag.avatar_url !== 'none' && ag.avatar_url !== 'undefined'
                ? ag.avatar_url : null;
            const init = bulle.querySelector('.bubble-initial');
            if (avatarUrl && init && !bulle.querySelector('img')) {
                const img = document.createElement('img');
                img.src = avatarUrl;
                img.alt = '';
                bulle.insertBefore(img, init);
                init.remove();
            }
        }

        if (type === 'sphere') {
            state.membresSphereActuelle = new Set(Object.keys(agents));
            const moi = agents[state.monPseudo];
            if (moi) {
                state.monRoleActuel = moi.role || 'membre';
                state.peutGererSalons = moi.peut_gerer_salons || false;
                majBoutonCreerSalon();
            }
        }
        if (listeAmisData.length > 0) rafraichirListeAmisUI();
    }

    const ctxAttendu = (state.sidebarContexte === 'sphere') ? 'sphere' : 'amis';
    if (type !== ctxAttendu) return;

    const ul = document.getElementById('liste-pseudos');
    if (!ul) return;
    ul.innerHTML = '';

    const obtenirBadgeRole = (role) => {
        if (role === 'admin') return `<span class="role-crown" title="${t('agents.badge_admin_title')}"> 👑</span>`;
        return '';
    };
    const obtenirBadgeGlobal = (roleGlobal) => {
        if (roleGlobal === 'admin') return `<span class="role-global role-global-admin" title="${t('agents.badge_global_admin')}"> ⚔️</span>`;
        if (roleGlobal === 'modo') return `<span class="role-global role-global-modo" title="${t('agents.badge_global_modo')}"> 🛡️</span>`;
        return '';
    };

    const dicoCouleurs = { 'enligne': '#3fb950', 'occupe': '#f85149', 'absent': '#d29922', 'invisible': '#8b949e' };
    const nettoyerStatut = (statut) => {
        if (!statut) return 'invisible';
        return statut.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/\s+/g, '');
    };
    const genererAvatarHTML = (agent) => {
        const taille = "28px";
        if (agent.avatar_url && agent.avatar_url !== 'none' && agent.avatar_url !== 'undefined') {
            return `<div class="agent-mini-avatar" style="width: ${taille}; height: ${taille}; border-radius: 50%; border: 1px solid ${agent.couleur || '#58a6ff'}; background: url('${agent.avatar_url}') center/cover; flex-shrink: 0; margin-right: 5px;"></div>`;
        } else {
            const initiale = agent.pseudo ? agent.pseudo.charAt(0).toUpperCase() : '?';
            return `<div class="agent-mini-avatar" style="width: ${taille}; height: ${taille}; border-radius: 50%; border: 1px solid ${agent.couleur || '#58a6ff'}; background-color: #161b22; color: ${agent.couleur || '#58a6ff'}; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 0.8em; flex-shrink: 0; margin-right: 5px;">${initiale}</div>`;
        }
    };

    if (agents[state.monPseudo]) {
        const moisData = agents[state.monPseudo];

        const badge = document.getElementById('self-status-badge');
        if (badge) badge.className = 'status-badge-on-avatar status-' + moisData.statut;

        const selfAvatar = document.getElementById('self-avatar');
        const initAvatar = document.getElementById('self-avatar-initiale');
        if (selfAvatar) {
            if (moisData.avatar_url && moisData.avatar_url !== 'none' && moisData.avatar_url !== 'undefined') {
                selfAvatar.style.backgroundImage = `url('${moisData.avatar_url}')`;
                selfAvatar.style.backgroundSize = 'cover';
                selfAvatar.style.backgroundPosition = 'center';
                selfAvatar.style.backgroundColor = 'transparent';
                if (initAvatar) initAvatar.style.display = 'none';
            } else {
                selfAvatar.style.backgroundImage = 'none';
                selfAvatar.style.backgroundColor = moisData.couleur || '#58a6ff';
                if (initAvatar) {
                    initAvatar.style.display = 'block';
                    initAvatar.textContent = state.monPseudo.charAt(0).toUpperCase();
                }
            }
        }
    }

    const moi = agents[state.monPseudo];
    if (moi) {
        const maClasse = nettoyerStatut(moi.statut);
        const liMoi = document.createElement('li');
        liMoi.className = "agent-item-moi";
        liMoi.dataset.pseudo = moi.pseudo;
        liMoi.style.display = "flex";
        liMoi.style.alignItems = "center";
        const badgeMoi = obtenirBadgeRole(moi.role);
        const badgeGlobalMoi = obtenirBadgeGlobal(moi.role_global);
        const avatarMoi = genererAvatarHTML(moi);
        const badgeSphereMoi = moi.badge ? `<span class="msg-badge agent-badge" style="--badge-color:${moi.badge.color}" title="${moi.badge.sphereNom || ''}">${moi.badge.label}</span>` : '';
        const spTexteMoi = moi.spotify ? ((moi.spotify.titre || '') + ' — ' + (moi.spotify.artiste || '')) : '';
        const activiteMoi = moi.spotify
            ? `<span class="agent-activity" title="🎵 ${escapeHtml(spTexteMoi)}">♪ ${escapeHtml(spTexteMoi)}</span>`
            : '';
        liMoi.innerHTML = `<span class="status-dot ${maClasse}" style="background-color: ${dicoCouleurs[maClasse]} !important; flex-shrink: 0; margin-right: 8px;"></span>
                           ${avatarMoi}
                           <div class="agent-text">
                               <span class="agent-name" style="color: ${moi.couleur};">${nomAfficheDe(moi)}${badgeMoi}${badgeGlobalMoi}${badgeSphereMoi}</span>
                               ${activiteMoi}
                           </div>`;
        liMoi.onclick = () => naviguer('mp', { pseudo: moi.pseudo });
        ul.appendChild(liMoi);
    }

    const pseudosTries = Object.values(agents)
        .filter(agent => agent.pseudo !== state.monPseudo)
        .sort((a, b) => {
            if (a.enLigne !== b.enLigne) return b.enLigne - a.enLigne;
            return a.pseudo.localeCompare(b.pseudo);
        });

    let aAfficheSeparateur = false;
    pseudosTries.forEach(agent => {
        if (!agent.enLigne && !aAfficheSeparateur) {
            const separator = document.createElement('li');
            separator.className = "agent-separator";
            separator.innerHTML = `<h4>${t('agents.offline')}</h4>`;
            ul.appendChild(separator);
            aAfficheSeparateur = true;
        }

        const li = document.createElement('li');
        li.className = "agent-item";
        li.dataset.pseudo = agent.pseudo;
        li.style.display = "flex";
        li.style.alignItems = "center";

        const statutPropre = nettoyerStatut(agent.statut);
        const classeStatut = agent.enLigne ? statutPropre : 'invisible';
        const nbNotifs = notifications[agent.pseudo] || 0;
        const badgeHtml = nbNotifs > 0 ? `<span class="notif-badge" style="margin-left: auto;">${nbNotifs}</span>` : '';
        const badgeAgent = obtenirBadgeRole(agent.role);
        const badgeGlobalAgent = obtenirBadgeGlobal(agent.role_global);
        const badgeSphereAgent = agent.badge ? `<span class="msg-badge agent-badge" style="--badge-color:${agent.badge.color}" title="${agent.badge.sphereNom || ''}">${agent.badge.label}</span>` : '';
        // Activité affichée sous le pseudo : Spotify a la priorité (plus social),
        // sinon on retombe sur la Rich Presence Electron (app active).
        let activiteAgent = '';
        if (agent.spotify) {
            const spTexte = ((agent.spotify.titre || '') + ' — ' + (agent.spotify.artiste || ''));
            activiteAgent = `<span class="agent-activity" title="🎵 ${escapeHtml(spTexte)}">♪ ${escapeHtml(spTexte)}</span>`;
        } else if (agent.activite && agent.activite.name) {
            const nom = agent.activite.name;
            activiteAgent = `<span class="agent-activity" title="${escapeHtml(nom)}">🖥 ${escapeHtml(nom)}</span>`;
        }
        const avatarAgent = genererAvatarHTML(agent);

        li.innerHTML = `<span class="status-dot ${classeStatut}" style="background-color: ${dicoCouleurs[classeStatut]} !important; flex-shrink: 0; margin-right: 8px;"></span>
                        ${avatarAgent}
                        <div class="agent-text">
                            <span class="agent-name" style="color: ${agent.couleur}; opacity: ${agent.enLigne ? '1' : '0.4'};">${nomAfficheDe(agent)}${badgeAgent}${badgeGlobalAgent}${badgeSphereAgent}</span>
                            ${activiteAgent}
                        </div>
                        ${badgeHtml}`;

        li.onclick = () => naviguer('mp', { id: agent.id, pseudo: agent.pseudo });

        li.oncontextmenu = (e) => {
            e.preventDefault();
            e.stopPropagation();
            window.agentContextuelActuel = agent.pseudo;

            const menu = document.getElementById('agent-context-menu');
            const subMenu = document.getElementById('sphere-invite-submenu');
            if (subMenu) subMenu.style.display = 'none';

            const btnAdd = document.getElementById('ctx-add-friend');
            const btnRemove = document.getElementById('ctx-remove-friend');

            if (agent.pseudo === state.monPseudo) {
                btnAdd.style.display = 'none';
                btnRemove.style.display = 'none';
            } else if (window.mesAmisActuels && window.mesAmisActuels.includes(agent.pseudo)) {
                btnAdd.style.display = 'none';
                btnRemove.style.display = 'block';
            } else {
                btnAdd.style.display = 'block';
                btnRemove.style.display = 'none';
            }

            const sep = document.getElementById('ctx-mod-separator');
            const btnPromoModo = document.getElementById('ctx-promote-modo');
            const btnPromoAdmin = document.getElementById('ctx-promote-admin');
            const btnDemote = document.getElementById('ctx-demote');
            const btnBanSphere = document.getElementById('ctx-ban-sphere');
            const btnBanGlobal = document.getElementById('ctx-ban-global');
            btnPromoModo.style.display = 'none';
            btnPromoAdmin.style.display = 'none';
            btnDemote.style.display = 'none';
            btnBanSphere.style.display = 'none';
            btnBanGlobal.style.display = 'none';
            sep.style.display = 'none';

            const estCible = agent.pseudo !== state.monPseudo;
            const cibleRole = agent.role_global || 'user';
            const estSphereAdmin = !!state.sphereActuelleID && !!window._peutModererSalon;
            const estGlobalAdmin = state.monRoleGlobal === 'admin';
            const estGlobalModo  = state.monRoleGlobal === 'modo' || estGlobalAdmin;

            if (estCible && (estSphereAdmin || estGlobalModo) && state.sphereActuelleID) {
                btnBanSphere.style.display = 'block';
                sep.style.display = 'block';
            }
            if (estCible && estGlobalAdmin) {
                btnBanGlobal.style.display = 'block';
                sep.style.display = 'block';
            }
            if (estCible && estGlobalAdmin) {
                if (cibleRole === 'user') {
                    btnPromoModo.style.display = 'block';
                    btnPromoAdmin.style.display = 'block';
                } else if (cibleRole === 'modo') {
                    btnPromoAdmin.style.display = 'block';
                    btnDemote.style.display = 'block';
                } else if (cibleRole === 'admin') {
                    btnDemote.style.display = 'block';
                }
                sep.style.display = 'block';
            }

            menu.style.display = 'block';
            const menuW = menu.offsetWidth || 220;
            const menuH = menu.offsetHeight || 0;
            const margePx = 8;
            let left = e.clientX - menuW;
            let top = e.clientY;
            if (left < margePx) left = margePx;
            if (left + menuW > window.innerWidth - margePx) left = window.innerWidth - menuW - margePx;
            if (top + menuH > window.innerHeight - margePx) top = window.innerHeight - menuH - margePx;
            if (top < margePx) top = margePx;
            menu.style.left = `${left}px`;
            menu.style.top = `${top}px`;
        };

        ul.appendChild(li);
    });

    const statUsers = document.getElementById('stat-users');
    if (statUsers) statUsers.innerText = Object.keys(agents).length;
});

socket.on('initialiser-notifications', (notifs) => {
    for (const [pseudo, data] of Object.entries(notifs)) {
        if (pseudo === state.monPseudo) continue;
        if (state.notifications) state.notifications[pseudo] = data.count || 0;
        if (data.count > 0 && typeof gererBulleMP === 'function') {
            gererBulleMP(pseudo, data.couleur);
        }
    }
    // liste-agents arrive quasi-simultanément mais l'ordre est non-déterministe.
    // On re-tente les avatars après que les deux events sont garantis traités.
    setTimeout(() => {
        for (const [pseudo] of Object.entries(notifs)) {
            if (pseudo === state.monPseudo) continue;
            const bulle = document.querySelector(`.active-contact-bubble[data-pseudo="${pseudo}"]`);
            if (!bulle) continue;
            const init = bulle.querySelector('.bubble-initial');
            if (!init) continue;
            const ud = state.utilisateurs?.[pseudo];
            const av = ud?.avatar_url && ud.avatar_url !== 'none' && ud.avatar_url !== 'undefined' ? ud.avatar_url : null;
            if (av && !bulle.querySelector('img')) {
                const img = document.createElement('img');
                img.src = av;
                img.alt = '';
                bulle.insertBefore(img, init);
                init.remove();
            }
        }
    }, 300);
});

// ==========================================================================
//   MENU CONTEXTUEL AGENT (clic droit sur un agent)
// ==========================================================================

export async function actionAgent(action) {
    const cible = window.agentContextuelActuel;
    if (!cible) return;

    if (action !== 'choisir_sphere_invit') {
        document.getElementById('agent-context-menu').style.display = 'none';
        const subMenu = document.getElementById('sphere-invite-submenu');
        if (subMenu) subMenu.style.display = 'none';
    }

    switch (action) {
        case 'ajouter':
            socket.emit('envoyer-demande-ami', cible);
            popToast(t('toast.friend_request', {pseudo: cible}));
            break;

        case 'retirer': {
            const ok = await chaosNotify(t('confirm.remove_friend', {pseudo: cible}), t('confirm.remove_friend_title'), "confirm");
            if (ok) { socket.emit('supprimer-ami', cible); popToast(t('toast.removed', {pseudo: cible})); }
            break;
        }

        case 'appeler':
            window.appelerEnMP?.(cible);
            break;

        case 'lire':
            socket.emit('marquer-lu', { expediteur: cible, destinataire: state.monPseudo });
            popToast(t('toast.read', {pseudo: cible}));
            supprimerBulleSiLue(cible);
            break;

        case 'mp':
        case 'message':
            naviguer('mp', { pseudo: cible });
            break;

        case 'profil':
            ouvrirMenuAmi(null, cible);
            break;

        case 'choisir_sphere_invit': {
            const subMenu = document.getElementById('sphere-invite-submenu');
            subMenu.innerHTML = `<div class="dropdown-header">${t('sphere.invite_where')}</div>`;
            if (!window.mesSpheresActuelles || window.mesSpheresActuelles.length === 0) {
                subMenu.innerHTML += `<div class="menu-item" style="opacity:0.5;">${t('sphere.no_sphere_available')}</div>`;
            } else {
                window.mesSpheresActuelles.forEach(sphere => {
                    const item = document.createElement('div');
                    item.className = 'menu-item';
                    item.innerText = `🌀 ${sphere.nom}`;
                    item.onclick = () => {
                        socket.emit('generer-et-envoyer-invitation-mp', { sphereId: sphere.id, cible });
                        popToast(t('toast.sphere_invite', {sphere: sphere.nom, pseudo: cible}));
                        document.getElementById('agent-context-menu').style.display = 'none';
                        subMenu.style.display = 'none';
                    };
                    subMenu.appendChild(item);
                });
            }
            const rectMenu = document.getElementById('agent-context-menu').getBoundingClientRect();
            subMenu.style.left = `${rectMenu.right + 4}px`;
            subMenu.style.top = `${rectMenu.top}px`;
            subMenu.style.display = 'block';
            break;
        }

        case 'mute':
            window.ouvrirModalMute?.(cible);
            break;

        case 'mute_notif':
            window.agentsMuteNotif = window.agentsMuteNotif || [];
            if (window.agentsMuteNotif.includes(cible)) {
                window.agentsMuteNotif = window.agentsMuteNotif.filter(p => p !== cible);
                popToast(t('toast.muted_off', {pseudo: cible}));
            } else {
                window.agentsMuteNotif.push(cible);
                popToast(t('toast.muted_on', {pseudo: cible}));
            }
            break;

        case 'mute_audio':
            if (window.rtcState?.elementsAudio[cible]) {
                const estMute = window.rtcState.elementsAudio[cible].muted;
                window.rtcState.elementsAudio[cible].muted = !estMute;
                popToast(t(!estMute ? 'toast.audio_muted' : 'toast.audio_unmuted', {pseudo: cible}));
            } else {
                popToast(t('toast.not_in_vocal', {pseudo: cible}), "error");
            }
            break;

        case 'bloquer': {
            const okB = await chaosNotify(t('confirm.block', {pseudo: cible}), t('confirm.block_title'), "confirm");
            if (okB) { socket.emit('bloquer-agent', cible); popToast(t('toast.blocked', {pseudo: cible}), "error"); }
            break;
        }

        case 'promouvoir_modo': {
            const ok = await chaosNotify(t('confirm.promote', {pseudo: cible}), t('confirm.promote_title'), "confirm");
            if (ok) socket.emit('moderation-promouvoir', { pseudoCible: cible, role: 'modo' });
            break;
        }

        case 'promouvoir_admin': {
            const ok = await chaosNotify(t('confirm.promote_admin', {pseudo: cible}), t('confirm.promote_title'), "confirm");
            if (ok) socket.emit('moderation-promouvoir', { pseudoCible: cible, role: 'admin' });
            break;
        }

        case 'retrograder': {
            const ok = await chaosNotify(t('confirm.demote', {pseudo: cible}), t('confirm.demote_title'), "confirm");
            if (ok) socket.emit('moderation-promouvoir', { pseudoCible: cible, role: 'user' });
            break;
        }

        case 'ban_sphere':
            ouvrirBanModal(cible, state.sphereActuelleID, false);
            break;

        case 'ban_global':
            ouvrirBanModal(cible, null, true);
            break;
    }
}

// ==========================================================================
//   BAN SYSTEM
// ==========================================================================

let _banPending = { cible: null, sphereId: null, global: false };

export function ouvrirBanModal(cible, sphereId, estGlobal) {
    _banPending = { cible, sphereId: sphereId || null, global: !!estGlobal };
    document.getElementById('ban-target-name').textContent = cible;
    document.getElementById('ban-scope-label').textContent = estGlobal
        ? '— ban global (plateforme entière)'
        : '— de la sphère actuelle';
    document.getElementById('ban-raison').value = '';
    document.getElementById('ban-duree').value = '';
    document.getElementById('ban-modal').style.display = 'flex';
}

export function fermerBanModal() {
    document.getElementById('ban-modal').style.display = 'none';
}

export function confirmerBan() {
    const raison = document.getElementById('ban-raison').value.trim() || null;
    const duree  = document.getElementById('ban-duree').value || null;
    const { cible, sphereId, global: estGlobal } = _banPending;
    if (!cible) return;
    if (estGlobal) {
        socket.emit('ban-global', { ciblePseudo: cible, raison, dureeMinutes: duree ? parseInt(duree) : null });
    } else {
        socket.emit('ban-sphere', { ciblePseudo: cible, sphereId, raison, dureeMinutes: duree ? parseInt(duree) : null });
    }
    fermerBanModal();
}

export function ouvrirBanListModal(sphereId) {
    document.getElementById('ban-list-modal').style.display = 'flex';
    document.getElementById('ban-list-content').innerHTML = '<div style="color:#8b949e;padding:12px;">Chargement…</div>';
    socket.emit('lister-bans', { sphereId: sphereId || null });
}

export function fermerBanListModal() {
    document.getElementById('ban-list-modal').style.display = 'none';
}

socket.on('ban-ok', ({ ciblePseudo, sphereId, global: estGlobal }) => {
    popToast(`${ciblePseudo} a été banni${estGlobal ? ' globalement' : ' de la sphère'}.`, 'error');
});

socket.on('unban-ok', ({ banId, cible, sphereId }) => {
    popToast(`${cible} a été débanni.`, 'success');
    // Rafraîchir la liste affichée
    const content = document.getElementById('ban-list-content');
    const row = content?.querySelector(`[data-ban-id="${banId}"]`);
    if (row) row.remove();
    if (content && !content.querySelector('.ban-row')) {
        content.innerHTML = '<div style="color:#8b949e;padding:12px;">Aucun ban actif.</div>';
    }
});

socket.on('liste-bans', ({ bans, sphereId }) => {
    const content = document.getElementById('ban-list-content');
    if (!content) return;
    if (!bans.length) {
        content.innerHTML = '<div style="color:#8b949e;padding:12px;">Aucun ban actif.</div>';
        return;
    }
    content.innerHTML = bans.map(b => {
        const expire = b.expire_a
            ? `Expire le ${new Date(b.expire_a).toLocaleDateString('fr-FR', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' })}`
            : 'Permanent';
        const raison = b.raison ? `<span style="color:#8b949e;font-size:.85em;">${escapeHtml(b.raison)}</span>` : '';
        return `<div class="ban-row" data-ban-id="${b.id}" style="display:flex;align-items:center;justify-content:space-between;padding:10px 0;border-bottom:1px solid #21262d;gap:10px;">
            <div>
                <strong style="color:#e6edf3;">${escapeHtml(b.cible)}</strong>
                <div style="font-size:.8em;color:#8b949e;">Banni par ${escapeHtml(b.banni_par)} · ${expire}</div>
                ${raison}
            </div>
            <button onclick="window._debannir(${b.id})" style="background:#21262d;border:1px solid #30363d;color:#58a6ff;border-radius:6px;padding:5px 12px;cursor:pointer;white-space:nowrap;">Débannir</button>
        </div>`;
    }).join('');
});

window._debannir = (banId) => socket.emit('unban', { banId });

// Réception : je suis banni de cette sphère → redirectionner vers dashboard
socket.on('vous-etes-banni', ({ sphereId, raison }) => {
    const msg = raison
        ? `Tu as été banni de cette sphère : "${raison}".`
        : "Tu as été banni de cette sphère.";
    chaosNotify(msg, "Accès restreint", "alert");
    if (typeof window.basculerAffichage === 'function') window.basculerAffichage('dashboard');
});

socket.on('vous-etes-banni-global', ({ raison }) => {
    const msg = raison
        ? `Ton compte a été banni : "${raison}". Tu vas être déconnecté.`
        : "Ton compte a été banni de la plateforme. Tu vas être déconnecté.";
    chaosNotify(msg, "🚫 Ban global", "alert");
});

// ==========================================================================
//   SPOTIFY
// ==========================================================================

function _spotifyMajUI(st) {
    st = st || {};
    const etat = document.getElementById('spotify-etat');
    const lierBtn = document.getElementById('spotify-lier-btn');
    const delierBtn = document.getElementById('spotify-delier-btn');
    const shareRow = document.getElementById('spotify-share-row');
    const shareTog = document.getElementById('spotify-share-toggle');
    if (!etat) return;
    if (st.configure === false) {
        etat.textContent = 'Indisponible (non configuré côté serveur).';
        if (lierBtn) lierBtn.style.display = 'none';
        if (delierBtn) delierBtn.style.display = 'none';
        if (shareRow) shareRow.style.display = 'none';
        return;
    }
    if (st.lie) {
        etat.textContent = 'Connecté ✓';
        if (lierBtn) lierBtn.style.display = 'none';
        if (delierBtn) delierBtn.style.display = '';
        if (shareRow) shareRow.style.display = 'flex';
        if (shareTog) shareTog.checked = st.share !== false;
    } else {
        etat.textContent = 'Non connecté';
        if (lierBtn) lierBtn.style.display = '';
        if (delierBtn) delierBtn.style.display = 'none';
        if (shareRow) shareRow.style.display = 'none';
    }
}

socket.on('spotify-link-url', (d) => {
    const pop = window._spotifyPopup;
    if (d && d.error === 'not_configured') {
        popToast('Spotify non configuré côté serveur.', 'stream');
        if (pop && !pop.closed) pop.close();
        return;
    }
    if (d && d.url) {
        if (pop && !pop.closed) {
            pop.location = d.url;
        } else {
            const w = window.open(d.url, 'spotify_oauth', 'width=520,height=720');
            if (!w) popToast('Autorise les popups pour connecter Spotify, puis réessaie.', 'stream');
        }
    }
});

function _creerCarteSpotify(np) {
    const card = document.createElement('div');
    card.className = 'spotify-mini-card' + (np.url ? ' has-url' : '');
    if (np.url) card.onclick = () => window.open(np.url, '_blank', 'noopener');
    if (np.pochette) {
        const img = document.createElement('img');
        img.className = 'spotify-mini-card-art';
        img.src = np.pochette;
        img.alt = '';
        card.appendChild(img);
    } else {
        const ph = document.createElement('div');
        ph.className = 'spotify-mini-card-art-placeholder';
        ph.textContent = '♪';
        card.appendChild(ph);
    }
    const info = document.createElement('div');
    info.className = 'spotify-mini-card-info';
    info.innerHTML = `<div class="spotify-mini-card-label">En écoute sur Spotify</div>
        <div class="spotify-mini-card-title">${escapeHtml(np.titre || '—')}</div>
        <div class="spotify-mini-card-artist">${escapeHtml(np.artiste || '')}</div>`;
    card.appendChild(info);
    return card;
}

let _spotifyHbTimer = null, _spotifyLie = false, _spotifyShare = true;
function _spotifyMajHeartbeat() {
    const actif = _spotifyLie && _spotifyShare;
    if (actif && !_spotifyHbTimer) {
        const pulse = () => { if (document.visibilityState === 'visible') socket.emit('spotify-tick'); };
        pulse();
        _spotifyHbTimer = setInterval(pulse, 8000);
    } else if (!actif && _spotifyHbTimer) {
        clearInterval(_spotifyHbTimer);
        _spotifyHbTimer = null;
    }
}

socket.on('spotify-status', (st) => {
    _spotifyMajUI(st);
    if (st) { _spotifyLie = !!st.lie; _spotifyShare = st.share !== false; _spotifyMajHeartbeat(); }
});

socket.on('spotify-share-ok', (d) => {
    const tog = document.getElementById('spotify-share-toggle');
    if (tog && d) tog.checked = d.share !== false;
    if (d) { _spotifyShare = d.share !== false; _spotifyMajHeartbeat(); }
});

socket.on('spotify-presence', ({ pseudo, np } = {}) => {
    if (!pseudo) return;
    if (utilisateurs[pseudo]) utilisateurs[pseudo].spotify = np || null;
    else utilisateurs[pseudo] = { pseudo, spotify: np || null };
    _majActiviteAgent(pseudo);
});

function _majActiviteAgent(pseudo) {
    const np = (utilisateurs[pseudo] && utilisateurs[pseudo].spotify) || null;
    const txtLigne = np ? ('♪ ' + (np.titre || '') + ' — ' + (np.artiste || '')) : '';
    document.querySelectorAll(`#liste-pseudos li[data-pseudo="${CSS.escape(pseudo)}"]`).forEach(li => {
        const zone = li.querySelector('.agent-text');
        if (!zone) return;
        let act = zone.querySelector('.agent-activity');
        if (np) {
            if (!act) { act = document.createElement('span'); act.className = 'agent-activity'; zone.appendChild(act); }
            act.textContent = txtLigne;
            act.title = '🎵 ' + (np.titre || '') + ' — ' + (np.artiste || '');
        } else if (act) {
            act.remove();
        }
    });
    const pop = document.getElementById('profile-popover');
    if (pop && pop.style.display === 'block' && window._popSpotifyPseudo === pseudo) {
        _majPopoverSpotify(pseudo);
    }
    const ext = document.getElementById('modal-extended-profile');
    if (ext && ext.style.display !== 'none' && window._extProfilePseudo === pseudo) {
        _majActiviteSpotify(pseudo);
    }
}

export function _majPopoverSpotify(pseudo) {
    const popSp = document.getElementById('pop-spotify');
    if (!popSp) return;
    const np = (utilisateurs[pseudo] && utilisateurs[pseudo].spotify) || null;
    popSp.innerHTML = '';
    if (np) {
        popSp.style.display = 'block';
        popSp.style.padding = '0';
        popSp.appendChild(_creerCarteSpotify(np));
    } else {
        popSp.style.display = 'none';
    }
}

export function _majActiviteSpotify(pseudo) {
    const panel = document.getElementById('ext-panel-activite');
    if (!panel) return;
    const np = (utilisateurs[pseudo] && utilisateurs[pseudo].spotify) || null;
    let existCard = panel.querySelector('.spotify-mini-card');
    let existNoAct = panel.querySelector('#ext-no-activity-text');
    if (np) {
        if (existCard) existCard.remove();
        const card = _creerCarteSpotify(np);
        card.style.margin = '0 0 12px 0';
        card.style.width = '100%';
        card.style.boxSizing = 'border-box';
        panel.insertBefore(card, panel.firstChild);
        if (existNoAct) existNoAct.style.display = 'none';
    } else {
        if (existCard) existCard.remove();
        if (existNoAct) existNoAct.style.display = '';
    }
}

window.addEventListener('message', (e) => {
    if (!e) return;
    if (e.data === 'chaos-spotify-linked') {
        popToast('🎵 Spotify connecté !', 'success');
        socket.emit('spotify-status');
    } else if (e.data === 'chaos-spotify-error') {
        popToast('Échec de la connexion Spotify.', 'stream');
    }
});

// ==========================================================================
//   PARAMÈTRES — carte profil
// ==========================================================================

export function majParamsProfileCard(data) {
    const card = document.getElementById('modal-params');
    if (!card || card.style.display === 'none') return;

    const banner = document.getElementById('params-banner');
    _renderBanniere(banner, data.banniere_id, data.couleur_preferee);

    const av = document.getElementById('params-avatar');
    av.style.backgroundColor = data.couleur_preferee || '#58a6ff';
    if (data.avatar_url) {
        av.style.backgroundImage = `url('${data.avatar_url}')`;
        av.style.backgroundSize = 'cover';
        av.style.backgroundPosition = 'center';
        av.textContent = '';
    } else {
        av.style.backgroundImage = 'none';
        av.textContent = data.pseudo ? data.pseudo.charAt(0).toUpperCase() : '?';
    }

    const elPseudo = document.getElementById('params-pseudo');
    if (elPseudo) elPseudo.textContent = data.pseudo || '—';

    const elFieldPseudo = document.getElementById('params-field-pseudo');
    if (elFieldPseudo) elFieldPseudo.textContent = data.pseudo || '—';

    const elStatut = document.getElementById('params-field-statut');
    if (elStatut) elStatut.textContent = data.statut || '—';

    const elBio = document.getElementById('params-field-bio');
    if (elBio) elBio.textContent = data.bio || '—';

    const elNomAffiche = document.getElementById('edit-nom-affiche');
    if (elNomAffiche && data.nom_affiche !== undefined) elNomAffiche.value = data.nom_affiche || '';
}

// ─── EXTENSION DU SYSTÈME SOCIAL (À METTRE TOUT EN BAS DE SOCIAL.JS) ───
export function afficherOngletSocial(onglet) {
    document.querySelectorAll('.social-tab-btn').forEach(btn => {
        btn.classList.toggle('active', btn.dataset.tab === onglet);
    });
    
    const pMembres = document.getElementById('social-membres-panel');
    const pDemandes = document.getElementById('social-demandes-panel');
    
    if (pMembres)  pMembres.style.display  = onglet === 'membres'  ? 'block' : 'none';
    if (pDemandes) pDemandes.style.display = onglet === 'demandes' ? 'block' : 'none';
}

export function envoyerDemandeAmi() {
    const input = document.getElementById('social-add-friend-input');
    if (!input) return;
    const cible = input.value.trim();
    
    if (!cible) return popToast(t('social.empty_pseudo'), 'error');
    if (cible.toLowerCase() === (window.monPseudo || state.monPseudo || '').toLowerCase()) {
        return popToast(t('social.cannot_add_self'), 'error');
    }

    socket.emit('demande-ami-envoyer', { cible });
    input.value = '';
}

export function gererActionRelation(action, pseudoCible) {
    socket.emit('relation-action', { action, cible: pseudoCible });
}

export function initSocialUiElements() {
    // --- LE VORTEX (Aspiration des bulles de MP) ---
    const vortex = document.getElementById('vortex-container');
    if (vortex) {
        vortex.ondragover = (e) => {
            // On vérifie que c'est bien une bulle de contact et pas une sphère
            if (window._dragId) return; 
            e.preventDefault();
            vortex.style.transform = 'translateX(-50%) scale(1.4)';
        };

        vortex.ondragleave = () => {
            vortex.style.transform = 'translateX(-50%) scale(1)';
        };

        vortex.ondrop = (e) => {
            e.preventDefault();
            const pseudo = e.dataTransfer.getData("text/plain");
            const bulleCible = document.querySelector(`.active-contact-bubble[data-pseudo="${pseudo}"]`);
            
            if (bulleCible) {
                bulleCible.style.transition = "all 0.4s cubic-bezier(0.6, -0.28, 0.735, 0.045)";
                bulleCible.style.transform = "scale(0) rotate(720deg)";
                bulleCible.style.opacity = "0";
                
                setTimeout(() => {
                    bulleCible.remove();
                    const container = document.getElementById('active-conversations');
                    if (container && container.children.length === 0) {
                        const sep = document.getElementById('sep-mp');
                        if (sep) sep.style.display = 'none';
                    }
                }, 400);
            }
        };
    }

    // --- LES AVATARS CLIQUABLES (Ouverture du mini-profile) ---
    document.addEventListener('click', async (e) => {
        const avatar = e.target.closest('.avatar-clickable');
        const author = !avatar && e.target.closest('.message-author[data-pseudo]');
        const popover = document.getElementById('profile-popover');
        if (!popover) return;

        const cible = avatar ? avatar.dataset.username : (author ? author.dataset.pseudo : null);

        if (cible) {
            const maxLeft = window.innerWidth - 300;
            popover.style.top = `${Math.max(10, e.clientY - 50)}px`;
            popover.style.left = `${Math.min(maxLeft, e.clientX + 20)}px`;
            popover.style.display = 'block';

            const popUsername = document.getElementById('pop-username');
            const popAvatar = document.getElementById('pop-avatar');
            const popSpotify = document.getElementById('pop-spotify');

            if (popUsername) popUsername.textContent = cible;
            if (popAvatar) popAvatar.textContent = cible.charAt(0).toUpperCase();
            if (popSpotify) {
                popSpotify.innerHTML = '';
                popSpotify.style.display = 'none';
            }

            socket.emit('get-user-profile', cible);

        } else if (!e.target.closest('#profile-popover')) {
            popover.style.display = 'none';
        }
    });
}

export function supprimerBullesMPLues() {
    const refsNotifs = state.notifications || notifications; 
    if (refsNotifs) {
        Object.keys(refsNotifs).forEach(pseudo => supprimerBulleSiLue(pseudo));
    }
}